var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.771 17.1516L11.7697 11.7724L17.1474 11.7722C18.1803 11.7737 19.0197 10.9343 19.0182 9.90142C19.0212 8.86398 18.1835 8.02922 17.1491 8.02926L11.7698 8.02796L11.7715 2.64569C11.7716 1.61128 10.9308 0.776526 9.89938 0.773541C8.86649 0.775092 8.02713 1.61445 8.02709 2.64584L8.02688 8.02961L2.65672 8.0283C1.62231 8.02834 0.782951 8.8677 0.785937 9.89909C0.784405 10.4178 0.993083 10.8836 1.33182 11.2223C1.67208 11.5626 2.13786 11.7713 2.65506 11.7712L8.02674 11.771L8.02805 17.1533C8.02803 17.6705 8.23671 18.1363 8.57545 18.475C8.91419 18.8138 9.383 19.0224 9.89869 19.0239C10.9331 19.0239 11.7709 18.1861 11.771 17.1516Z",
    fill: "#FFFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ebe04586a800c7efb24442c224766c98.svg";
export { ForwardRef as ReactComponent };